import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.26_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.61.1_@types_7b44b789cdfb1a3228c5d3c4404f0b8f/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Lexend\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"lexend\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/AnalyticsWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimulateErrorControls"] */ "/vercel/path0/src/app/components/ErrorHandling/SimulateErrorControls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/SpeedInsightsWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/styles-registry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClerkProviderWithRedirects"] */ "/vercel/path0/src/browser-lib/appProviders/clerkProviderWithRedirects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PHProvider"] */ "/vercel/path0/src/browser-lib/appProviders/posthogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/browser-lib/cookie-consent/CookieConsentProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/browser-lib/gleap/gleap.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AppComponents/App/AppHooks.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/context/Menu/MenuProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OakNotificationsProvider"] */ "/vercel/path0/src/context/OakNotifications/OakNotificationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SaveCountProvider"] */ "/vercel/path0/src/context/SaveCount/SaveCountProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/app-global.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/oakThemeApp.ts");
